<template>
  <div class="container-flued homeSlide1">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 leftSide">
          <p>
            When you use our services, we gather, use, and disclose information
            as outlined in this privacy policy. You agree to the collection,
            transfer, manipulation, storage, disclosure, and other uses of Your
            Information (collectively, “Use of Your Information”) as specified
            in this Privacy Policy by accessing or using our services.
          </p>
          <h5>Definitions:</h5>
          <h5>Service:</h5>
          <p>
            All Leads Provider's service is the website
            <a href=" https://Allleadsprovider.com"
              >https://Allleadsprovider.com</a
            >
          </p>
          <h5>Personal Data:</h5>
          <p>
            Personal Data refers to information about an actual individual who
            can be recognized from that information (or from that information
            and other information in our knowledge.
          </p>
          <h5>Usage Data:</h5>
          <p>
            Usage data is information that is automatically gathered from the
            service infrastructure or from users of the service (e.g., the
            length of a page visit).
          </p>
          <h5>Cookies:</h5>
          <p>
            Information generated by a web server and saved on a user's
            workstation. Through the use of cookies, a website can monitor a
            user's browsing habits and preferences and, with the user's consent,
            save them on the user's hard drive.
          </p>
          <h5>Data Controller:</h5>
          <p>
            The natural or legal person who (alone or jointly or in common with
            other individuals) sets the purposes for which and the method in
            which any personal information are or are to be processed is
            referred to as the Data Controller. We are the Data Controller of
            your personal information for the intent of this Privacy Policy.
          </p>
          <h5>Service Provider:</h5>
          <p>
            Any individual or entity who handles data on behalf of the data
            controller is referred to as a "service provider. We might employ
            several service providers' services to handle your data more
            efficiently.
          </p>
          <h5>User:</h5>
          <p>
            Any living person who uses our service and is the subject of
            personal data is referred to as a user or data subject.
          </p>
          <h5>Information We Collect and Its Usage:</h5>
          <p>
            A variety of information about you may be received or gathered by
            us, including the data listed below.
          </p>
          <p>
            <b>Personal Data:</b> We may ask you to provide us with personally
            identifying information that can be used to contact or identify you
            while using our Service ("Personal Data"). Personal identifiable
            information may include First and Last Name, Phone Number, Email
            Address, Postal Address.
          </p>
          <p>
            <b>Usage Data:</b> Additionally, we might gather data about how
            users access and utilize the service ("Usage Data"). The Internet
            Protocol address (IP address) of your computer, the type and version
            of your browser, the pages you visit on our service, the time and
            date of your visit, the amount of time you spend on those pages,
            unique device identifiers, and other diagnostic data are just a few
            examples of the information that could be included in this usage
            data.
          </p>
          <h5>Where Your Data Is Used:</h5>
          <p>
            We might provide or contact you for Service updates, promotional
            materials, surveys, offers, quotes, personalized information and
            other information from us or our business partners.
          </p>
          <p>For the purpose of customer support.</p>
          <p>
            To compile insightful data or analysis so that we can enhance our
            service.
          </p>
          <p>To keep an eye on how our service is being used.</p>
          <p>To identify, stop, and resolve technological problems</p>
          <p>
            To deliver and uphold our Service and to inform you of any
            modifications to our Service.
          </p>
          <h5>
            The General Data Protection Regulation's (GDPR): Legal Foundation
            for Processing Personal Data:
          </h5>
          <p>
            All Leads Provider may utilize your personally identifiable
            information for the following reasons:
          </p>
          <p>To carry out a contract with you.</p>
          <p>
            You have granted us permission to do so. The processing is in our
            legitimate interests and is not in conflict with your rights.
          </p>
          <p>In order to comply with the law</p>
          <p>
            If you are a resident of the European Economic Area (EEA), All Leads
            Provider’s legal basis for collecting and processing the personal
            information contained in this Privacy Policy is determined by the
            Personal Data we collect and the precise context in which it is
            collected.
          </p>
          <h5>Data Retention:</h5>
          <p>
            Usage Data will also be kept on record by All Leads Provider for
            internal analysis. Usage data is typically kept for a shorter amount
            of time, unless it is needed to bolster the security or enhance the
            performance of our service, or unless we are required by law to keep
            it longer.
          </p>
          <p>
            To the extent required to fulfill our legal duties, settle disputes,
            and uphold our policies and legal agreements, we will keep and
            utilize your personal information.
          </p>
          <h5>Data Transfer:</h5>
          <p>
            The United States is where we operate our services. Please be
            advised that any information you submit to us will be transferred to
            the United States if you are situated in the European Union, Canada,
            or any other country outside of the United States. You agree to this
            transfer by using our services or giving us Your Information.
          </p>
          <h5>Data Disclosure:</h5>
          <p>
            All Leads Provider reserves the right to disclose your personal
            information if required by law or in the good faith belief that such
            action is reasonably necessary to comply with legal process, respond
            to claims, or protect the rights, property, or safety of our
            company, employees, customers, or the general public.
          </p>
          <h5>Options for How We Will Use and Share Your Information:</h5>
          <p>
            If you do not want us to collect cookies, you can configure your
            browser to refuse cookies or to notify you when cookies are sent.
            Please keep in mind that if you do this, some elements of our
            Services may become inaccessible or cease to work properly.
          </p>
          <p>
            To unsubscribe from our promotional emails, send an email to
            info@allleadsprovider.com or follow the instructions in any
            promotional message you get from us. We will continue send you
            transactional messages even if you opt out of receiving marketing
            messages. This includes answers to your questions.
          </p>
          <p>
            Through your phone's settings, you can disable the GPS location and
            push notifications to stop providing your location information.
          </p>
          <h5>Links to Third Party Websites:</h5>
          <p>
            A third-party link will direct you to a different website or
            platform that is outside of our control. The platform's or website's
            privacy policies are not covered by this policy. Examine the privacy
            policies of other businesses carefully. Regarding these third
            parties, we have no liability.
          </p>
          <h5>Children Information:</h5>
          <p>
            We don't intentionally gather personally identifying data from those
            who are younger than eighteen. Please get in touch with us if you
            are a parent or guardian and you know that your child has given us
            personal information. We take action to delete information from our
            servers if we learn that we have obtained Personal Data from minors
            without getting parental approval.
          </p>
          <h5>Contacting Us:</h5>
          <p>
            Please send an email to info@allleadsprovider.com if you have any
            questions or issues about our privacy policies or would want to make
            a request regarding Your Information.
          </p>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="container-flued homeSlide1">
    <div class="row">
      <div class="col-12">
        <h2>"Stay Prepared, Stay Protected</h2>
        <h5>Insurance for Life's Uncertainties"</h5>
        <h6>Your Shield in an Uncertain World"</h6>
        <a href="#" class="yellowButton">Get Your Quote</a>
      </div>
    </div>
  </div> -->
  <!--container-->
</template>

<script>
export default {
  name: 'PrivacyDesc',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lan="scss">
.homeSlide1 {
  background: rgba(242, 242, 242, 0.6);
  padding-bottom: 40px;
  .leftSide {
    padding-top: 40px;
    h2 {
      color: #f5f5f5;
      font-family: Inter;
      font-size: 80px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-shadow: 2px 4px 3px rgba(0, 0, 0, 0.2),
        0px -4px 5px rgba(255, 255, 255, 0.2);
      margin-top: 40px;
      animation: 0.5s ease-in 0s 1 slideInFromLeft;
      text-align: center;
    }
    h5 {
      color: #292341;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      /* animation: 0.7s ease-in 0s 1 slideInFromLeft; */
    }
    p {
      color: #292341;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      a {
        color: rgba(226, 184, 66, 0.91);
      }
    }
    .row {
      margin-right: 0px;
    }
    .yellowButton {
      width: 220px;
      margin: 0 auto;
      display: block;
      text-align: center;
      margin-top: 40px;
      margin-bottom: 50px;
      animation: 1.1s ease-in 0s 1 slideInFromLeft;
    }
  }
  .rightSide {
    .circle1 {
      animation: 0.8s ease-in 0s 1 slideInFromLeft;
      margin-top: 40px;
      img {
        width: 100%;
        /* filter: drop-shadow(0 0 0.75rem #00000099); */
      }
    }
    .circle2 {
      animation: 1s ease-in 0s 1 slideInFromLeft;
      margin-top: 80px;
      img {
        width: 100%;
        filter: drop-shadow(0 0 0 #00000099);
      }
    }
    .circle3 {
      animation: 1.2s ease-in 0s 1 slideInFromLeft;
      margin-top: -80px;
      margin-left: -30px;
      img {
        width: 100%;
        filter: drop-shadow(0 0 0.75rem #00000099);
      }
    }
    .circle4 {
      animation: 1.4s ease-in 0s 1 slideInFromLeft;
      margin-top: -165px;
      margin-left: -20px;
      img {
        width: 120%;
        filter: drop-shadow(0 0 0.75rem #00000099);
      }
    }
  }
}
@keyframes slideInFromLeft {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.yellowButton {
  padding: 14px 16px;
  border-radius: 8px;
  background: #ffc93c;
  color: #000;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: none;
}
@media screen and (min-width: 1500px) {
  .homeSlide1 {
    h5 {
      text-align: center;
    }
  }
}
@media screen and (max-width: 1300px) {
  .homeSlide1 {
    .leftSide {
      h2 {
        font-size: 48px;
      }
      h5 {
        font-size: 18px;
      }
      h6 {
        font-size: 24px;
      }
      p {
        font-size: 16px;
      }
    }
  }
  .rightSide {
    .circle4 {
      margin-top: -144px !important;
    }
  }
}
@media screen and (min-width: 992px) {
  .headerBG {
    .navbar-nav {
      width: 100%;
      .nav-item {
        width: 20%;
        text-align: center;
        font-weight: 400;
        font-size: 16px;
        .getQouteA {
          font-size: 14px;
          margin-top: 0px;
          display: inline-block;
        }
      }
    }
  }
  .dropdown-menu {
    background-color: #242f9b !important;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    margin-top: 20px;
  }
}
@media screen and (max-width: 992px) {
  .getQouteA {
    width: 160px;
    margin: 0 auto;
    margin-top: 10px;
    background-color: #ffc93c;
  }

  .navbar-collapse {
    background-color: #242f9bee;
    padding-left: 10px;
    margin-top: 21px;
    .nav-item {
      font-weight: 400;
      font-size: 16px;
      box-sizing: border-box;
      a {
        color: #ffffff !important;
      }
      .getQouteA {
        width: 98%;
        text-align: center;
        display: inline-block;
        color: #242f9b !important;
        box-sizing: border-box;
        margin-bottom: 10px;
      }
    }
  }
  .homeSlide1 {
    .leftSide {
      h2 {
        font-size: 48px;
        margin-top: 40px;
      }
      h5 {
        font-size: 18px;
        width: 100%;
        /* text-align: center; */
      }
      h6 {
        font-size: 32px;
      }
      p {
        font-size: 16px;
      }
    }
  }
}
@media screen and (max-width: 540px) {
  .hideOnMobile {
    display: none;
  }
  .homeSlide1 {
    h2 {
      font-size: 32px;
      margin-top: 40px;
    }
    h5 {
      font-size: 32px;
      width: 100%;
      /* text-align: center; */
    }
    h6 {
      font-size: 24px;
    }
  }
  .rightSide {
    .circle4 {
      margin-top: -30% !important;
      img {
        width: 100%;
      }
    }
  }
}
</style>
